import React, { useEffect, useRef, useCallback } from "react";
import PropTypes from "prop-types";
import CommonModal from "./CommonModal";
import useReckonApi from "../../hooks/useReckonApi";
import useMyobApi from "../../hooks/useMyobApi";
import useMixpanelEventAction from "../../config/mixpanel/useMixpanelEventAction";
import useGA4EventAction from "../../config/GoogleAnalytics/useGA4EventAction";
import { useNavigate } from "react-router-dom";
import { showToast } from "../../utils/utils";
import ErrorBoundary from "../error-boundary";
import {
  commonErrMsg,
  responseStatus,
  fundedInvoicesData,
  Select
} from "../../locales/en";
import Modalstyle from "./modal.module.scss";
import ModalFallback from "../error-boundary/fallback/ModalFallback";
import { INVOICE } from "../../route/paths";

export const CashbookListModal = ({
  isOpen,
  toggle,
  CashbookIdDetails,
  isCompanyFiles,
  handleSyncInvoices
}) => {
  const initialRender = useRef(true);
  const { ReckonSelectSpecificBook } = useReckonApi();
  const { MyobSelectSpecificBook } = useMyobApi();
  const navigate = useNavigate();
  const { reckonConnectMixpanelEvent, myobConnectMixpanelEvent } =
    useMixpanelEventAction();
  const { myobConnectGA4Event, reckonConnectGA4Event } = useGA4EventAction();

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    }
  }, []);

  const handleSelectedBookName = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue) {
      handleSpecificBookSelect(selectedValue);
    }
  };

  const handleSpecificBookSelect = useCallback(
    async (bookId) => {
      try {
        if (isCompanyFiles) {
          await MyobSelectSpecificBook({ companyId: bookId });
          myobConnectMixpanelEvent();
          myobConnectGA4Event();
          handleSyncInvoices();
          showToast(commonErrMsg?.myobSuccess, responseStatus?.success);
        } else {
          await ReckonSelectSpecificBook({ bookId });
          reckonConnectMixpanelEvent();
          reckonConnectGA4Event();
          showToast(commonErrMsg?.reckonSuccess, responseStatus?.success);
        }
        toggle();
        navigate(INVOICE);
      } catch {
        toggle();
        showToast(commonErrMsg?.notFoundBook, responseStatus?.error);
        navigate(INVOICE);
      }
    },
    [
      ReckonSelectSpecificBook,
      MyobSelectSpecificBook,
      isCompanyFiles,
      toggle,
      navigate,
      myobConnectMixpanelEvent,
      myobConnectGA4Event,
      reckonConnectMixpanelEvent,
      reckonConnectGA4Event
    ]
  );

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={fundedInvoicesData?.CashbookListModal?.title}
      bodyClassName={Modalstyle.modalInputwrap}
      hideFooter
    >
      <ErrorBoundary fallback={<ModalFallback fixHeight="250px" />}>
        <div className="mb-3">
          <div className={Modalstyle.formInput}>
            <select
              name="bookId"
              id="bookId"
              className="mb-2 form-control"
              onChange={handleSelectedBookName}
            >
              <option value="">{Select}</option>
              {CashbookIdDetails?.map((item, index) => {
                const value = isCompanyFiles ? item.Id : item.BookId;
                const label = isCompanyFiles ? item.Name : item.BookName;
                return (
                  <option value={value} key={index}>
                    {label}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
      </ErrorBoundary>
    </CommonModal>
  );
};

CashbookListModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  CashbookIdDetails: PropTypes.array,
  isCompanyFiles: PropTypes.bool,
  handleSyncInvoices: PropTypes.func
};

export default CashbookListModal;
